(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["datu-frame-study"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('datu-frame-study')) {
    customElements.define('datu-frame-study', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const controls = this.querySelector('.datu-frame-study__switch');
        if (!controls) return;
        controls.hidden = false;
        controls.addEventListener('click', (event) => {
          const button = event.target.closest('[data-presentation-choice]');
          if (!button || !controls.contains(button)) return;
          this.dataset.presentation = button.dataset.presentationChoice;
          controls.querySelectorAll('button').forEach((item) => {
            item.setAttribute('aria-pressed', String(item === button));
          });
        }, { signal: this.abortController.signal });
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["datu-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('datu-action-hero')) {
    customElements.define('datu-action-hero', class extends HTMLElement {
      connectedCallback() {
        this.updateChrome = () => {
          const promo = document.querySelector('.datu-entry-promo--banner');
          const header = document.querySelector('height-observer[variable="header"]');
          const height = (promo?.getBoundingClientRect().height || 0) + (header?.getBoundingClientRect().height || 0);
          this.style.setProperty('--datu-chrome-height', Math.ceil(height) + 'px');
        };
        this.chromeObserver = new ResizeObserver(this.updateChrome);
        for (const element of document.querySelectorAll('.datu-entry-promo--banner, height-observer[variable="header"]')) this.chromeObserver.observe(element);
        window.addEventListener('pageshow', this.updateChrome);
        this.updateChrome();
      }
      disconnectedCallback() {
        this.chromeObserver?.disconnect();
        window.removeEventListener('pageshow', this.updateChrome);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["datu-our-pick-popup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('datu-pick-popup-v3')) {
  customElements.define('datu-pick-popup-v3', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.dialog = this.querySelector('dialog');
      this.stateOutput = this.querySelector('[data-pick-review-state]');
      this.storageKey = 'datu:our-pick:v2:' + this.dataset.variantId;
      this.shown = false;
      this.checking = false;
      this.retryAt = 0;
      this.start = Date.now();
      try {
        const savedStart = Number(sessionStorage.getItem(this.storageKey + ':start'));
        this.start = savedStart > 0 ? savedStart : this.start;
        sessionStorage.setItem(this.storageKey + ':start', String(this.start));
        this.dismissedUntil = Number(localStorage.getItem(this.storageKey + ':dismissed')) || 0;
        this.seen = sessionStorage.getItem(this.storageKey + ':seen') === '1';
        this.added = this.dataset.inCart === 'true' || sessionStorage.getItem(this.storageKey + ':added') === '1';
        this.storageReady = true;
      } catch (error) { this.storageReady = false; }
      this.querySelector('[data-pick-dismiss]').addEventListener('click', () => this.hide(true), { signal });
      this.querySelectorAll('[data-pick-explore]').forEach(link => link.addEventListener('click', () => this.hide(true), { signal }));
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.hide(true); }, { signal });
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.dialog.open && !this.otherDialog()) {
          event.preventDefault();
          this.hide(true);
        }
      }, { signal });
      document.addEventListener('datu:featured-added', event => {
        if (String(event.detail?.variantId) === this.dataset.variantId) this.markAdded(false);
      }, { signal });
      document.addEventListener('variant:add', event => {
        if (this.hasVariant(event.detail?.items)) this.markAdded();
      }, { signal });
      document.addEventListener('cart:change', event => {
        if (this.hasVariant(event.detail?.cart?.items)) this.markAdded();
      }, { signal });
      document.addEventListener('dialog:before-show', event => {
        if (!this.contains(event.target) && this.dialog.open) this.hide(false);
      }, { capture: true, signal });
      document.addEventListener('visibilitychange', () => this.reconsider(), { signal });
      window.addEventListener('scroll', () => this.reconsider(), { passive: true, signal });
      window.addEventListener('resize', () => this.reconsider(), { passive: true, signal });
      this.querySelectorAll('[data-review-action]').forEach(button => button.addEventListener('click', () => this.review(button.dataset.reviewAction), { signal }));
      this.observer = new MutationObserver(() => {
        if (this.dialog.open && (this.featureVisible() || this.otherDialog())) this.hide(false);
      });
      this.observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open', 'aria-hidden', 'aria-modal', 'aria-expanded'] });
      this.timer = setInterval(() => this.reconsider(), 1000);
      this.reconsider();
    }
    disconnectedCallback() { this.cleanup(); }
    cleanup() {
      this.controller?.abort();
      this.observer?.disconnect();
      clearInterval(this.timer);
    }
    setState(state) {
      this.dataset.state = state;
      if (this.stateOutput) this.stateOutput.textContent = state;
    }
    hasVariant(items) {
      return Array.isArray(items) && items.some(item => String(item.variant_id ?? item.id).split('/').pop() === this.dataset.variantId && Number(item.quantity ?? 1) > 0);
    }
    featureVisible() {
      return [...document.querySelectorAll('.datu-pick, .datu-pair')].some(element => {
        const rect = element.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && rect.top < window.innerHeight && rect.bottom > 0;
      });
    }
    otherDialog() {
      return [...document.querySelectorAll('dialog[open], [role="dialog"], [role="alertdialog"], [aria-modal="true"], header details[open], .header details[open]')].some(element => {
        if (element === this.dialog || this.dialog.contains(element) || this.contains(element)) return false;
        const style = getComputedStyle(element);
        return element.getClientRects().length > 0 && style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0' && !element.hidden;
      });
    }
    guard(manual = false) {
      if (this.dataset.mobileOnly === 'true' && !window.matchMedia('(max-width: 749px)').matches) return 'desktop';
      if (/\/(?:cart|checkout|checkouts)(?:\/|$)/.test(location.pathname)) return 'excluded-page';
      if (this.dataset.available !== 'true') return 'unavailable';
      if (document.visibilityState !== 'visible') return 'background';
      if (this.added) return 'added';
      if (this.otherDialog()) return 'other-dialog';
      if (manual) return '';
      if (this.dataset.designMode === 'true') return 'editor';
      if (!this.storageReady) return 'storage-unavailable';
      if (this.dismissedUntil > Date.now()) return 'dismissed';
      if (this.seen || this.shown) return 'seen';
      if (Date.now() - this.start < Number(this.dataset.delay) * 1000) return 'delay';
      if (this.dataset.mobileOnly === 'true') {
        const feature = document.querySelector('.datu-pair');
        if (window.scrollY < window.innerHeight * .75 || feature?.getBoundingClientRect().bottom > 0) return 'before-browsing';
      }
      if (this.featureVisible()) return 'feature-visible';
      if (document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) return 'typing';
      return '';
    }
    async reconsider(manual = false) {
      if (this.dialog.open) {
        if (this.featureVisible() || this.otherDialog() || this.dataset.mobileOnly === 'true' && !window.matchMedia('(max-width: 749px)').matches) this.hide(false);
        return;
      }
      if (this.checking) return;
      const blocked = this.guard(manual);
      if (blocked) { this.setState(blocked); return; }
      if (Date.now() < this.retryAt) { this.setState('cart-unconfirmed'); return; }
      this.checking = true;
      try {
        const response = await fetch(this.dataset.cartUrl, { cache: 'no-store', signal: AbortSignal.timeout(5000) });
        if (!response.ok) { this.retryAt = Date.now() + 30000; this.setState('cart-unconfirmed'); return; }
        const cart = await response.json();
        if (this.hasVariant(cart.items)) { this.markAdded(); return; }
        if (!this.isConnected || this.guard(manual)) return;
        this.lastFocus = document.activeElement;
        this.dialog.show();
        this.shown = true;
        this.seen = true;
        try { sessionStorage.setItem(this.storageKey + ':seen', '1'); } catch (error) {}
        if (!manual && this.lastFocus !== document.body && this.lastFocus?.getClientRects().length) this.lastFocus.focus({ preventScroll: true });
        this.setState('shown');
      } catch (error) { this.retryAt = Date.now() + 30000; this.setState('cart-unconfirmed'); }
      finally { this.checking = false; }
    }
    hide(remember) {
      if (remember) {
        this.dismissedUntil = Date.now() + 7 * 24 * 60 * 60 * 1000;
        try { localStorage.setItem(this.storageKey + ':dismissed', String(this.dismissedUntil)); } catch (error) {}
      }
      const focusInside = this.dialog.contains(document.activeElement);
      this.dialog.close();
      if (focusInside && this.lastFocus?.isConnected && this.lastFocus.getClientRects().length) this.lastFocus.focus({ preventScroll: true });
      this.setState(remember ? 'dismissed' : this.added ? 'added' : 'seen');
    }
    markAdded(close = true) {
      this.added = true;
      try { sessionStorage.setItem(this.storageKey + ':added', '1'); } catch (error) {}
      if (close && this.dialog.open) this.hide(false);
      this.setState('added');
    }
    review(action) {
      if (action === 'show') return this.reconsider(true);
      if (action === 'reset') {
        this.dialog.close();
        [':seen', ':added', ':start'].forEach(suffix => sessionStorage.removeItem(this.storageKey + suffix));
        localStorage.removeItem(this.storageKey + ':dismissed');
        this.dataset.inCart = 'false';
        this.connectedCallback();
        return;
      }
      this.dialog.style.setProperty('--datu-popup-width', action === 'desktop' ? '440px' : action === '390' ? '366px' : '296px');
      this.dialog.style.setProperty('--datu-popup-limit', action === 'desktop' ? '680px' : action === '390' ? '724px' : '448px');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["datu-welcome-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('datu-welcome-popup')) {
    customElements.define('datu-welcome-popup', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.contentObserver?.disconnect();
        clearTimeout(this.timer);
        this.controller = new AbortController();
        this.dataset.state = 'initializing';
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true, signal: this.controller.signal });
        } else {
          this.initialize();
        }
      }
      initialize() {
        if (!this.isConnected) return;
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) {
          this.dataset.state = 'waiting-for-content';
          this.contentObserver = new MutationObserver(() => {
            if (!this.querySelector('dialog')) return;
            this.contentObserver.disconnect();
            this.initialize();
          });
          this.contentObserver.observe(this, { childList: true, subtree: true });
          return;
        }
        this.preview = this.dataset.preview === 'true';
        this.testMode = this.dataset.testMode === 'true';
        this.storageKey = this.preview ? 'datu:welcome10:preview:v1' : 'datu:welcome10:v2';
        this.dataset.state = 'ready';
        const enableReopenButtons = () => document.querySelectorAll('[data-datu-welcome-open]').forEach(button => {
          button.hidden = false;
          button.setAttribute('aria-controls', this.dialog.id);
        });
        enableReopenButtons();
        document.addEventListener('shopify:section:load', enableReopenButtons, options);
        document.addEventListener('click', event => {
          if (event.target.closest('[data-datu-welcome-open]')) this.open();
        }, options);
        window.addEventListener('hashchange', () => {
          if (window.location.hash === '#welcome10') this.open();
        }, options);
        this.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, options);
        this.dialog.addEventListener('close', () => {
          if (this.submitInProgress) return;
          this.dataset.state = 'closed';
          if (!this.testMode) this.store('dismissed_until', Date.now() + 7 * 86400000);
          this.previousFocus?.focus?.({ preventScroll: true });
        }, options);
        const previewForm = this.querySelector('[data-preview-form]');
        const liveForm = this.querySelector('form:not([data-preview-form])');
        liveForm?.addEventListener('submit', () => {
          this.submitInProgress = true;
          this.dialog.close();
        }, { ...options, capture: true });
        if (previewForm) {
          const previewSubmit = event => {
            event.preventDefault();
            if (previewForm.reportValidity()) this.showState(true);
          };
          previewForm.addEventListener('submit', previewSubmit, options);
          previewForm.querySelector('[data-welcome-submit]').addEventListener('click', previewSubmit, options);
        }
        const succeeded = this.querySelector('[data-welcome-server-success]');
        const failed = this.querySelector('[data-welcome-server-error]');
        if (succeeded || failed) {
          this.showState(Boolean(succeeded));
          if (succeeded && !this.testMode) this.store('subscribed', '1');
          this.open();
          return;
        }
        if (this.testMode) { this.timer = setTimeout(() => this.open(), 600); return; }
        if (window.location.hash === '#welcome10') { this.open(); return; }
        if (this.dataset.homepage !== 'true') { this.dataset.state = 'homepage-only'; return; }
        try {
          if (localStorage.getItem(this.storageKey + ':subscribed') === '1') { this.dataset.state = 'subscribed'; return; }
          if (Number(localStorage.getItem(this.storageKey + ':dismissed_until')) > Date.now()) { this.dataset.state = 'dismissed'; return; }
          if (sessionStorage.getItem(this.storageKey + ':seen') === '1') { this.dataset.state = 'seen'; return; }
        } catch (error) {}
        const delay = Number(this.dataset.delay || 8) * 1000;
        this.openAt = Date.now() + delay;
        const resume = () => {
          if (!document.hidden && this.dataset.state.startsWith('waiting') && Date.now() >= this.openAt) this.maybeOpen();
        };
        document.addEventListener('visibilitychange', resume, options);
        window.addEventListener('pageshow', resume, options);
        this.dataset.state = 'waiting';
        this.timer = setTimeout(() => this.maybeOpen(), delay);
      }
      maybeOpen() {
        clearTimeout(this.timer);
        const occupied = Array.from(document.querySelectorAll('dialog[open], cart-drawer[open], search-drawer[open], navigation-drawer[open]')).some(element => element !== this.dialog && element.getClientRects().length > 0);
        if (document.hidden || occupied || document.activeElement?.matches('input,textarea,select,[contenteditable="true"]')) {
          this.dataset.state = 'waiting-for-page';
          this.timer = setTimeout(() => this.maybeOpen(), 5000);
          return;
        }
        this.open();
      }
      open() {
        clearTimeout(this.timer);
        if (!this.dialog.open) { this.previousFocus = document.activeElement; this.dialog.showModal(); }
        this.dataset.state = 'open';
        if (!this.testMode) {
          try {
            sessionStorage.setItem(this.storageKey + ':seen', '1');
          } catch (error) {}
        }
      }
      showState(success) {
        this.querySelector('[data-welcome-intro]').hidden = success;
        const panel = this.querySelector('[data-welcome-success]');
        panel.hidden = !success;
        if (success) panel.focus({ preventScroll: true });
      }
      store(name, value) { try { localStorage.setItem(this.storageKey + ':' + name, String(value)); } catch (error) {} }
      disconnectedCallback() { this.controller?.abort(); this.contentObserver?.disconnect(); clearTimeout(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('datu-product-rotation')) {
  customElements.define('datu-product-rotation', class extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.rotate(), { once: true });
      } else {
        queueMicrotask(() => this.rotate());
      }
    }

    rotate() {
      if (!this.isConnected || this.dataset.rotationReady === 'true' || this.dataset.designMode === 'true') return;

      const source = this.querySelector('template');
      const list = this.parentElement.querySelector(':scope > product-list.product-list, :scope > product-list > scroll-carousel.product-list');
      const requestedCount = Number.parseInt(this.dataset.count, 10);
      if (!source || !list || !Number.isFinite(requestedCount) || requestedCount < 1) return;

      const candidates = Array.from(source.content.children).filter(card => card.matches('product-card[handle]'));
      const cards = Array.from(new Map(candidates.map(card => [card.getAttribute('handle'), card])).values());
      if (cards.length === 0) return;

      const count = Math.min(requestedCount, cards.length);
      let previous = Array.from(list.children).map(card => card.getAttribute('handle')).filter(Boolean);

      try {
        const saved = JSON.parse(sessionStorage.getItem(this.dataset.storageKey) || 'null');
        if (Array.isArray(saved)) previous = saved.filter(value => typeof value === 'string');
      } catch {}

      const previousSet = new Set(previous);
      const fresh = cards.filter(card => !previousSet.has(card.getAttribute('handle')));
      const seen = cards.filter(card => previousSet.has(card.getAttribute('handle')));
      const shuffle = items => {
        for (let i = items.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [items[i], items[j]] = [items[j], items[i]];
        }
        return items;
      };
      const selected = [...shuffle(fresh), ...shuffle(seen)].slice(0, count);
      const replacement = list.cloneNode(false);

      for (const card of selected) replacement.append(document.importNode(card, true));
      const endCard = list.querySelector(':scope > .datu-carousel-end-card');
      if (endCard) replacement.append(endCard.cloneNode(true));

      this.dataset.rotationReady = 'true';
      if (list.matches('scroll-carousel')) {
        const wrapper = list.parentElement;
        const replacementWrapper = wrapper.cloneNode(true);
        replacementWrapper.querySelector('scroll-carousel').replaceWith(replacement);
        wrapper.replaceWith(replacementWrapper);
      } else {
        list.replaceWith(replacement);
      }

      try {
        sessionStorage.setItem(this.dataset.storageKey, JSON.stringify(selected.map(card => card.getAttribute('handle'))));
      } catch {}
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
